import { observer } from 'mobx-react-lite'
import { useInjection } from '@core/providers/inversify-react.provider'
import { ConnectivityPresenter } from './connectivity.presenter'

export const OfflineBannerComponent = observer(() => {
  const presenter: ConnectivityPresenter = useInjection(ConnectivityPresenter)
  const vm = presenter.viewModel

  if (!vm.showOfflineBanner && !vm.showStaleNotice) return null

  // No own fixed positioning — BannerStackComponent (mounted once) provides
  // the single fixed bottom container both this and VersionBannerComponent
  // stack inside, so two banners showing at once don't overlap each other.
  return (
    <div className="bg-amber-500 px-4 py-2 text-center text-sm font-medium text-white">
      {vm.showOfflineBanner && <div>{vm.offlineMessage}</div>}
      {vm.showStaleNotice && <div className="font-normal">{vm.staleMessage}</div>}
    </div>
  )
})
